export default __webpack_public_path__ + "static/media/online-learning.0a6d5ce0.svg";